/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

interface BvFiltersConnectedFilterControlItemSignature {
  Blocks: {
    default: [];
  };
}

export default class BvFiltersConnectedFilterControlItemComponent extends Component<BvFiltersConnectedFilterControlItemSignature> {
  @tracked focused = false;
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvFilters::ConnectedFilterControlItem': typeof BvFiltersConnectedFilterControlItemComponent;
    'bv-filters/connected-filter-control-item': typeof BvFiltersConnectedFilterControlItemComponent;
  }
}
